import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var Mail = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M28 6c1.654 0 3 1.346 3 3v14.667c0 1.654-1.346 3-3 3H4c-1.654 0-3-1.346-3-3V9c0-1.654 1.346-3 3-3zm0 18.667c.552 0 1-.449 1-1V9.214l-12.375 9.9a1.001 1.001 0 01-1.25 0L3 9.214v14.453c0 .551.448 1 1 1zM27.315 8H4.685L16 17.053z" })), '0 0 32 32', 'Mail');
//# sourceMappingURL=Mail.js.map